'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var GrabIcon = function GrabIcon(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var className = props.className,
      type = props.type,
      spin = props.spin; // eslint-disable-line

  if (type.startsWith('grabicon-')) {
    return _react2.default.createElement('i', { className: (0, _classnames2.default)('anticon', 'grabicon', type, { 'anticon-spin': spin }, className) });
  } else if (type.startsWith('iconfont-')) {
    return _react2.default.createElement('i', { className: (0, _classnames2.default)('anticon', 'iconfont', type, { 'anticon-spin': spin }, className) });
  }

  return _react2.default.createElement(_icon2.default, props);
};

GrabIcon.defaultProps = {
  onClick: function onClick() {},
  spin: false,
  type: '',
  title: ''
};

GrabIcon.propTypes = {
  onClick: _propTypes2.default.func,
  spin: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  title: _propTypes2.default.string
};

GrabIcon.displayName = 'Icon';

exports.default = GrabIcon;